import { Icon, type TIconProps } from '~/components/icon'
import type { TCheckboxSizes } from '../../types'
import * as Comp from './helper-text.styles'

type IHelperTextProps = {
  children: string
  size?: TCheckboxSizes
  testID?: string
}

export function CheckboxHelperText({
  size = 'md',
  testID,
  ...props
}: IHelperTextProps) {
  const iconSizeMapping: Record<TCheckboxSizes, TIconProps['size']> = {
    md: 'tiny',
    ml: 'tiny',
    lg: 'tiny',
    xl: 'tiny',
  }

  return (
    <Comp.Root testID={testID}>
      <Icon
        size={iconSizeMapping[size]}
        symbol="rdicon-warning-circle"
        color="colorTextDangerAlternative"
      />
      <Comp.Label numberOfLines={2}>{props.children}</Comp.Label>
    </Comp.Root>
  )
}
